import { RefundDto } from './refund.dto';

export class OrderCreationDto {
  constructor(dto) {
    this.user_id = dto.user_id;
    this.items = dto.items;
  }
}

export class OrderNonAdminCreationDto {
  constructor(dto) {
    /** @type {number} */
    this.user_id = dto.user_id;
    this.items = dto.items;
    this.discounts = dto.discount;
  }
}

export class OrderDetailDto {
  constructor(dto) {
    this.id = dto.id;
    this.user = dto.user;

    /** @type {RefundDto[]} */
    this.refunds = dto.refunds;
  }
}

export class OrderUpdateDto {
  constructor(data) {
    this.allow_assign = data.allow_assign;
    this.is_paid = data.is_paid;
  }
}
